import React, { useContext, useEffect, useMemo, useState } from "react";
import { fetchApplications } from "../Menu/helpers";
import { Loader } from "@egovernments/digit-ui-react-components";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Popover, TableSortLabel, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { ArrowDownward } from "@mui/icons-material";
import { convertEpochToDateDMY } from "../../../utils";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FaFileExcel } from "react-icons/fa";

const EmpReceivedFiles = () => {
  let user = Digit.UserService.getUser();
  // const tenantId = Digit.ULBService.getCurrentTenantId();
  const { businessServices: userBusinessServices, tenantId, count, officerRole } = useSelector((state) => state.empInbox);

  // const officerRole = user?.info?.roles?.filter((item) => item.code !== "EMPLOYEE");
  const history = useHistory();
  // const [userBusinessServices, setUserBusinessServices] = useState({});
  const hasAuthorizedRoles = officerRole?.some((role) => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole?.some((role) => role.code === "Authorized_Officer");
  const { applications, isOfficerLTP, isFetching } = fetchApplications(tenantId, userBusinessServices, officerRole);
  console.log("applicationsFromEmpReceivedFiles", applications, officerRole);
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");
  // const [dscCount, setDscCount] = useState(0);
  // const [filteredAndSortedData, setFilteredAndSortedData] = useState([]);
  // const [paginatedData, setPaginatedData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([
    "srNo",
    "applicationNo",
    "ltpName",
    "ownerName",
    "serviceType",
    "proposedActivity",
    "plotArea",
    "schemeName",
    "plotNo",
    "status",
    "applicationDate",
    "recievedDate",
  ]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { t } = useTranslation();
  function getApprovalLetter(item) {
    const pdfUrl = item?.approvalLetter;
    window.open(pdfUrl, "_blank");
  }
  const [filters, setFilters] = useState({
    applicationNo: "",
    landId: "",
    ownerName: "",
    applicationType: "",
    status: "",
    date: "",
  });
  // Column configuration
  const allColumns = [
    {
      id: "srNo",
      label: t("FASTPAS.GLOBAL.SERIALNUMBER"),
      filterable: false,
      width: "5%",
    },
    {
      id: "applicationNo",
      label: t("FASTPAS.GLOBAL.APPLICATION.NUMBER"),
      filterable: true,
      sortable: true,
      render: (item) => <a onClick={() => handleTakeAction(item)}>{item?.applicationId || "-"}</a>,
      width: "12%",
    },
    {
      id: "ltpName",
      label: "LTP Name",
      filterable: true,
      sortable: true,
      render: (item) => item?.ltpName || "-",
      width: "12%",
    },
    {
      id: "ownerName",
      label: "Name",
      filterable: true,
      sortable: true,
      render: (item) => item?.owner || "-",
      width: "12%",
    },
    {
      id: "serviceType",
      label: "Service Type",
      filterable: true,
      sortable: true,
      render: (item) => item?.applicationType || "Map Submission",
      width: "12%",
    },
    {
      id: "proposedActivity",
      label: "Proposed Activity",
      filterable: true,
      sortable: true,
      render: (item) => item?.proposedActivity || "Residential",
      width: "12%",
    },
    {
      id: "plotArea",
      label: "Plot Area",
      filterable: true,
      sortable: true,
      render: (item) => item?.plotArea,
      width: "8%",
    },
    {
      id: "schemeName",
      label: "Scheme Name",
      filterable: true,
      sortable: true,
      render: (item) => item?.schemeName,
      width: "12%",
    },
    {
      id: "plotNo",
      label: "Plot No",
      filterable: true,
      sortable: true,
      render: (item) => item?.plotNo || "N/A",
      width: "8%",
    },
    {
      id: "status",
      label: "Status",
      filterable: true,
      sortable: true,
      render: (item) => t(`WF_BPA_MAP_${item?.status}`) || "-",
      width: "12%",
    },
    {
      id: "applicationDate",
      label: "Submission Date",
      filterable: false,
      sortable: true,
      render: (item) => convertEpochToDateDMY(item?.date) || "-",
      width: "8%",
    },
    {
      id: "recievedDate",
      label: "Received Date",
      filterable: false,
      sortable: true,
      render: (item) => convertEpochToDateDMY(item?.recievedTime) || "-",
      width: "8%",
    },
  ];

  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = (item) => {
        switch (orderBy) {
          case "applicationNo":
            return item?.applicationId?.toLowerCase() || "";

          case "ltpName":
            return item?.ltpName?.toLowerCase() || "";

          case "ownerName":
            return item?.owner?.toLowerCase() || "";

          case "serviceType":
            return item?.applicationType?.toLowerCase() || "";

          case "proposedActivity":
            return item?.proposedActivity?.toLowerCase() || "";

          case "plotArea":
            return Number(item?.plotArea) || 0;

          case "schemeName":
            return item?.schemeName?.toLowerCase() || "";

          case "plotNo":
            return item?.plotNo?.toLowerCase() || "";

          case "status":
            return t(`WF_BPA_MAP_${item?.status}`)?.toLowerCase() || "";

          case "applicationDate":
            return item?.date || 0;

          default:
            return "";
        }
      };

      const aValue = getValue(a);
      const bValue = getValue(b);

      // 🔥 important: handle numbers + strings safely
      if (typeof aValue === "number" && typeof bValue === "number") {
        return order === "desc" ? bValue - aValue : aValue - bValue;
      }

      if (order === "desc") {
        return bValue.localeCompare(aValue);
      } else {
        return aValue.localeCompare(bValue);
      }
    };
  };
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value,
    });
    setPage(0);
  };

  // Handle clear filter
  const handleClearFilter = (property) => {
    setFilters({
      ...filters,
      [property]: "",
    });
  };

  // Handle global search
  const handleGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };

  // Apply filtering and global search
  const getFilteredData = () => {
    let filteredData = applications?.table || [];

    // Apply global search first
    if (globalSearch) {
      filteredData = filteredData?.filter((item) => {
        return (
          matchesSearch(item?.owner, globalSearch) ||
          matchesSearch(item?.applicationId, globalSearch) ||
          matchesSearch(item?.land_Id, globalSearch) ||
          matchesSearch(t(item?.applicationType), globalSearch) || // FIXED
          matchesSearch(t(`WF_BPA_MAP_${item?.status}`), globalSearch) || // FIXED
          matchesSearch(convertEpochToDateDMY(item?.date), globalSearch)
        );
      });
    }

    // Apply column filters
    if (filters.ownerName) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.owner, filters.ownerName));
    }

    if (filters.landId) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.land_Id?.toString(), filters.landId));
    }

    if (filters.applicationNo) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.applicationId, filters.applicationNo));
    }

    if (filters.applicationType) {
      filteredData = filteredData.filter((item) => matchesSearch(t(item?.applicationType), filters.applicationType));
    }
    if (filters.status) {
      filteredData = filteredData.filter((item) => matchesSearch(t(`WF_BPA_MAP_${item?.status}`), filters.status));
    }

    return filteredData;
  };
  const columns = allColumns.filter((col) => selectedColumns.includes(col.id));

  const filteredData = getFilteredData();

  // Apply sorting
  const sortedData = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return [];
    return filteredData.slice().sort(getComparator(order, orderBy));
  }, [filteredData, order, orderBy]);

  console.log("sortedData291", sortedData, filteredData, order, orderBy);

  const isApplyForDSCPresent = (status) => {
    if (
      status === "CTP_AFTER_PAYMENT" ||
      status === "PAYMENT_DONE_VC" ||
      status === "VC_AFTER_PAYMENT" ||
      status === "ATP_AFTER_PAYMENT" ||
      status === "ATP_AFTER_PAYMENT" ||
      status === "EE_TP_AFTER_PAYMENT" ||
      status === "SECRETORY_AFTER_PAYMENT"
    ) {
      return true;
    } else return false;
  };

  const dscApplications = useMemo(
    () => sortedData.filter((item) => item?.status?.startsWith("APPLY_FOR_DSC") || isApplyForDSCPresent(item?.status)),
    [sortedData]
  );

  const dscCount = dscApplications.length;

  const filteredAndSortedData = useMemo(() => {
    return selectedAction === "Apply For DSC" ? dscApplications : sortedData;
  }, [selectedAction, dscApplications, sortedData]);

  const paginatedData = useMemo(() => {
    return filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredAndSortedData, page, rowsPerPage]);

  const handleTakeAction = (item) => {
    console.log("itemFromTakeAction", item, item?.businessService);
    switch (item?.businessService) {
      case "BPAREG":
        Digit.SessionStorage.del("EMP_LTP");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/professional/${item?.applicationId}`);
        break;
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
      case "BPA_COMPLETION_DA":
        Digit.SessionStorage.del("EMP_MAPSUB");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationId}`);
        // handleClose();
        break;
      case "BPA_MAPPLINTH_DA":
        Digit.SessionStorage.del("EMP_MAPSUB");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationId}`);
        break;
      case "BPA_PURCHASEFAR_DA":
        Digit.SessionStorage.del("EMP_MAPSUB");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationId}`);
        break;
      case "BPA_PRESS_RELEASE":
        Digit.SessionStorage.del("EMP_MAPSUB");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/application/FORM_PRESSRELEASE/${item?.applicationId}`);
        break;
      case "BPA_LANDUSE_CONVERSION_DA":
        Digit.SessionStorage.del("EMP_MAPSUB");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/application/FORM_LANDUSECONVERSION/${item?.applicationId}`);
        break;
      case "BPA_PURCHASEFAR_DA":
      case "BPA_PURCHASEFAR_AVP":
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item?.applicationId}`);
        // handleClose();
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
      case "BPA_KYP_DA":
        Digit.SessionStorage.del("EMP_LANDUSE");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item?.applicationId}`);
        // handleClose();
        break;
      default:
        if (item.businessService.startsWith("BPA_NOC")) {
          history.push(`/digit-ui/employee/obps/application/NOC/${item?.applicationId}`);
        } else {
          console.log("Unhandled Business Service", item.businessService);
        }
    }
    // setAnchorEl(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleOpenColumnFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExcelDownload = () => {
    // Export filtered items with ALL columns
    const exportData = filteredData.map((app, idx) => {
      const row = {};
      allColumns.forEach((col) => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });

    Digit.Download.Excel(exportData, "Received Files");
  };

  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      // Don't allow deselecting all columns - at least one must remain
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
    s;
  };
  if (isFetching) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      <TableContainer className="table-container">
        <div>
          <caption className="emp-table-caption">{t("FASTPAS.FILES.RECEIVED.TEXT")}</caption>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={handleOpenColumnFilter}
              size="small"
              sx={{
                height: "27px",
                fontSize: "12px",
                borderColor: "rgb(31, 74, 124)",
                color: "rgb(31, 74, 124)",
              }}
            >
              {t("FASTPAS.GLOBAL.FILTERS.TEXT")}({selectedColumns.length === allColumns.length ? "All" : selectedColumns.length}){" "}
            </Button>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search here..."
              value={globalSearch}
              onChange={(e) => handleGlobalSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ background: "#2A3F54", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                  </InputAdornment>
                ),
                endAdornment: globalSearch && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => handleGlobalSearch("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                padding: "0px",
                height: "25px", // sets outer height
                "& .MuiInputBase-root": {
                  height: "27px",
                  padding: "0px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgb(31, 74, 124)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "0", // top/bottom padding controls the internal height
                  fontSize: "12px",
                },
              }}
            />
            <button
              onClick={handleExcelDownload}
              title="Export to Excel"
              style={{
                height: "35px",
                padding: "5px 0px",
                marginRight: "8px",
              }}
              disabled={filteredData.length === 0}
            >
              {" "}
              <FaFileExcel style={{ fontSize: "20px", color: "rgb(85 108 214)" }} />
            </button>
          </div>
        </div>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseColumnFilter}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className="select-column-popover">
            <Typography variant="subtitle2" gutterBottom>
              Select Columns to Display
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ padding: "0px" }}
                  checked={selectedColumns.length === allColumns.length}
                  indeterminate={selectedColumns.length > 0 && selectedColumns.length < allColumns.length}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedColumns(allColumns.map((col) => col.id));
                    } else {
                      // Optionally, keep at least one column selected
                      setSelectedColumns([allColumns[0].id]);
                    }
                  }}
                />
              }
              sx={{ margin: "0px", fontWeight: "bold" }}
              label="Select All"
            />
            {allColumns.map((column) => (
              <div key={column.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ padding: "0px" }}
                      checked={selectedColumns.includes(column.id)}
                      onChange={() => handleColumnToggle(column.id)}
                      disabled={column.id === "srNo" && selectedColumns.length === 1}
                    />
                  }
                  sx={{ margin: "0px" }}
                  label={column.label}
                />
              </div>
            ))}
          </div>
        </Popover>
        <div className="risk-type-bar" style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
          <button
            className={`risk-type-button ${selectedAction === "Apply For DSC" ? "active" : ""}`}
            disabled={dscCount === 0}
            style={{
              cursor: dscCount === 0 ? "not-allowed" : "pointer",
            }}
            onClick={() => setSelectedAction((prev) => (prev === "Apply For DSC" ? "" : "Apply For DSC"))}
          >
            Apply For DSC <span className="count">({dscCount})</span>
          </button>
        </div>
        <Table stickyHeader className="application-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th display="flex" alignItems="center">
                  {column.label}
                  {column.sortable && (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleSort(column.id)}
                      sx={{
                        color: "white !important", // Force white text
                        "& .MuiTableSortLabel-icon": {
                          opacity: "1 !important", // Force icon to always be visible
                          color: "white !important", // Force white icon
                        },
                        "&:hover": {
                          color: "white !important", // Ensure hover doesn't change color
                        },
                      }}
                      // Force the icon to render even when inactive
                      IconComponent={(props) => (
                        <ArrowDownward
                          {...props}
                          sx={{
                            color: "white !important",
                            opacity: 1, // Ensure icon is always visible
                          }}
                        />
                      )}
                    />
                  )}
                </th>
              ))}
            </tr>
            <tr>
              {columns?.map((column) => (
                <td key={column.id}>
                  {column.filterable && (
                    <TextField
                      variant="standard"
                      size="small"
                      value={filters[column.id] || ""}
                      onChange={(e) => handleFilterChange(column.id, e.target.value)}
                      InputProps={{
                        endAdornment: filters[column.id] && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => handleClearFilter(column.id)} sx={{ color: "white" }}>
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiInput-input": {
                          color: "black !important",
                          fontSize: "0.75rem",
                        },
                        width: "100%",
                      }}
                    />
                  )}
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {false ? (
              <tr>
                <td colSpan={columns.length} align="center">
                  Loading...
                </td>
              </tr>
            ) : paginatedData.length === 0 ? (
              <tr>
                <td colSpan={columns.length} align="center">
                  No records found
                </td>
              </tr>
            ) : (
              paginatedData.map((item, index) => (
                <tr hover key={index}>
                  {columns.map((column) => (
                    <td key={`${index}-${column.id}`}>{column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item)}</td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={filteredAndSortedData?.length || applications?.table?.length || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />
    </React.Fragment>
  );
};

export default EmpReceivedFiles;
